import React from 'react';
import GitHubIcon from '@mui/icons-material/GitHub';
import MailIcon from '@mui/icons-material/Mail';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TelegramIcon from '@mui/icons-material/Telegram';
import Fab from '@mui/material/Fab';
import AOS from "aos";
import "aos/dist/aos.css";
import { Discord, Medium } from 'react-bootstrap-icons';
import './Connect.scss';

const Connect = () => {

    React.useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);

    const openLink = (link) => {
        window.open(link);
    }

    return (
        <>
            <div className="d-flex flex-row justify-content-center connect">
                <div 
                    data-aos="fade-up" 
                    data-aos-delay="50"
                    data-aos-duration="900"
                    data-aos-easing="ease-in-out"
                >
                    <Fab onClick={() => openLink('https://github.com/AnshikaAgrawal5501')}>
                        <GitHubIcon />
                    </Fab>
                </div>
                <div 
                    data-aos="fade-up" 
                    data-aos-delay="100"
                    data-aos-duration="900"
                    data-aos-easing="ease-in-out"
                >
                    <Fab onClick={() => openLink('https://www.linkedin.com/in/anshika-agrawal-406441197/')}>
                        <LinkedInIcon />
                    </Fab>
                </div>
                <div 
                    data-aos="fade-up" 
                    data-aos-delay="150"
                    data-aos-duration="900"
                    data-aos-easing="ease-in-out"
                >
                    <Fab onClick={() => openLink('mailto:anshikaagrawal5501@gmail.com')}>
                        <MailIcon />
                    </Fab>
                </div>
                <div 
                    data-aos="fade-up" 
                    data-aos-delay="200"
                    data-aos-duration="900"
                    data-aos-easing="ease-in-out"
                >
                    <Fab onClick={() => openLink('https://medium.com/@anshikaagrawal5501')}>
                        <Medium />
                    </Fab>
                </div>      
                <div 
                    data-aos="fade-up" 
                    data-aos-delay="250"
                    data-aos-duration="900"
                    data-aos-easing="ease-in-out"
                >
                    <Fab onClick={() => openLink('https://discordapp.com/users/748126738235523142')}>
                        <Discord />
                    </Fab>
                </div>    
                <div 
                    data-aos="fade-up" 
                    data-aos-delay="300"
                    data-aos-duration="900"
                    data-aos-easing="ease-in-out"
                >
                    <Fab onClick={() => openLink('https://t.me/shiney_5501')}>
                        <TelegramIcon />
                    </Fab>
                </div>  
            </div>
        </>
    )
}

export default Connect;